import { stringLiteral } from '@execonline-inc/decoders';
import { Decoder, succeed } from 'jsonous';
import { WindowMessage } from './Types';

export const windowMessageDecoder: Decoder<WindowMessage> = succeed({}).assign(
  'kind',
  stringLiteral('complete-and-close'),
);
